import { render, staticRenderFns } from "./NotasFinalista.vue?vue&type=template&id=410ac74f&"
import script from "./NotasFinalista.vue?vue&type=script&lang=js&"
export * from "./NotasFinalista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports